import React from "react";
import { Alert, Form, Input } from "antd";
import { inject, observer } from "mobx-react";
import "moment/locale/zh-cn";
import "moment/locale/en-au";
import classnames from "classnames";

import Language from "../../../language/language";
import {
  EduSelect,
  SchoolSelect,
  MajorsSelect,
  TimePicker,
  PhoneNumInput,
} from "./inputsLego";

import "./style/personalInfo.scss";

@inject("languageStore", "authStore")
@observer
class PersonalInfoInput extends React.Component {
  state = {
    name: "",
    phoneNumber: "",
    email: "",
    education: "",
    school: "",
    college: "",
    major: "",
    start: "",
    end: "",
    disabledStart: "",
    disabledEnd: "",
  };

  componentDidMount() {
    this.props.onRef(this);
    this.formatBasicInfo();
    this.formatEducation();
  }

  formatBasicInfo = () => {
    const { user } = this.props.authStore;
    if (Object.keys(user).length > 0) {
      const { contact_email: email, nickname, phone_number } = user;
      this.setState({
        name: nickname,
        email,
        phoneNumber: phone_number,
      });
    }
  };

  /**
   * 计算用户最高学历
   * 计算逻辑：结束时间最晚的记录 > 开始时间最晚的记录 > id最小的记录
   */
  formatEducation = () => {
    const { educations } = this.props.authStore;
    if (educations.length === 1) {
      const result = educations[0];
      this.setState({
        education: result.degree,
        school: result.college_name,
        college: result.institute_name,
        major: result.major,
        start: result.begin_at,
        end: result.end_at,
      });
      return;
    } else if (educations.length > 1) {
      const educationLists = educations.sort((itemA, itemB) => {
        const endA = itemA.end_at,
          endB = itemB.end_at,
          startA = itemA.begin_at,
          startB = itemB.begin_at,
          idA = itemA.id,
          idB = itemB.id;
        if (endA !== endB) {
          return new Date(endA) - new Date(endB);
        } else if (startA !== startB) {
          return new Date(startA) - new Date(startB);
        }

        return idB - idA;
      });
      const result = educationLists.slice(-1)[0];

      this.setState({
        education: result.degree,
        school: result.college_name,
        college: result.institute_name,
        major: result.major,
        start: result.begin_at,
        end: result.end_at,
        disabledStart: result.begin_at,
        disabledEnd: result.end_at,
      });
    }
  };

  getPlaceHolder = (lang, action, item) =>
    `${this.props.languageStore.getResource(
      lang,
      action
    )}${this.props.languageStore.getResource(lang, item)}`;

  handleSubmit = () => {
    const { getFieldsError, validateFields } = this.props.form;
    validateFields();
    const errors = getFieldsError();
    return Object.keys(errors).filter((item) => !!errors[item]).length > 0;
  };

  getPersonalInfoValues = () => {
    const { getFieldsValue } = this.props.form;
    return JSON.stringify(getFieldsValue());
  };

  judgeEmpty = (rule, value, callback) => {
    const { required, lang, label } = rule;
    if (required && !value) {
      callback(
        this.props.languageStore.getResource(lang, "IS_REQUIRED", [
          this.props.languageStore.getResource(lang, label),
        ])
      );
      return;
    }
    callback();
  };

  /**
   * 手机号校验规则（11位数字）
   */
  judgePhoneNumber = (rule, value, callback) => {
    const { lang } = rule;
    const [preValue, phoneNum] = (value || "").split(" ");

    if (!preValue || isNaN(Number(phoneNum)) || phoneNum.length !== 11) {
      callback(this.props.languageStore.getResource(lang, "WRONG_PHONE"));
      return;
    }
    callback();
  };

  judgeEmail = (rule, value, callback) => {
    const { lang } = rule;
    if (!value.includes("@")) {
      callback(this.props.languageStore.getResource(lang, "WRONG_EMAIL"));
      return;
    }
    callback();
  };

  handleStartTime = (value) => {
    this.setState({
      disabledStart: value,
    });
  };

  handleEndTime = (value) => {
    this.setState({
      disabledEnd: value,
    });
  };

  render() {
    const { input } = this.props;
    const { getFieldDecorator } = this.props.form;
    const {
      name,
      phoneNumber,
      email,
      education,
      school,
      college,
      major,
      start,
      end,
      disabledStart,
      disabledEnd,
    } = this.state;

    const lang = this.props.languageStore.lang;

    const isRequired = !!(input && input.required);


    const formItemLabelList = [
      {
        label: "NAME",
        itemName: "name",
        inputAction: "ENTER",
        component: Input,
        initialValue: name,
      },
      {
        label: "PHONE_NUMBER",
        itemName: "phoneNumber",
        inputAction: "ENTER",
        component: PhoneNumInput,
        validator: this.judgePhoneNumber,
        initialValue: phoneNumber,
      },
      {
        label: "EMAIL",
        itemName: "email",
        inputAction: "ENTER",
        component: Input,
        validator: this.judgeEmail,
        initialValue: email,
      },
      {
        label: "H_EDUCATION",
        itemName: "education",
        inputAction: "SELECT",
        component: EduSelect,
        initialValue: education,
        lang,
      },
      {
        label: "H_SCHOOL",
        itemName: "school",
        inputAction: "ENTER",
        component: SchoolSelect,
        initialValue: school,
        type: "string",
      },
      {
        label: "H_COLLEGE",
        itemName: "college",
        inputAction: "ENTER",
        component: Input,
        initialValue: college,
      },
      {
        label: "H_MAJOR",
        itemName: "major",
        inputAction: "ENTER",
        component: MajorsSelect,
        initialValue: major,
      },
      {
        label: "H_START_TIME",
        itemName: "start",
        inputAction: "SELECT",
        component: TimePicker,
        initialValue: start,
        onChange: this.handleStartTime,
        disabledEnd,
      },
      {
        label: "H_END_TIME",
        itemName: "end",
        inputAction: "SELECT",
        component: TimePicker,
        initialValue: end,
        onChange: this.handleEndTime,
        disabledStart,
      },
    ];

    return (
      <Form className="personalInfoInput">
        <Alert
          message={<Language resource="PERSONAL_INFO_ALERT" />}
          type="warning"
          showIcon
          style={{ marginTop: "20px" }}
        />
        {formItemLabelList.map((item, index) => {
          const {
            label,
            inputAction,
            component: InputComponent,
            itemName,
            validator,
            type = "string",
            initialValue,
            ...restProps
          } = item;
          const placeholder = this.getPlaceHolder(lang, inputAction, label);
          const formLabl = <Language resource={label} />;

          return (
            <Form.Item
              className={classnames(
                "personalInfoInput__item",
                `personalInfoInput__item--${lang}`
              )}
              key={index}
              label={formLabl}
            >
              {getFieldDecorator(itemName, {
                validateFirst: true,
                initialValue,
                rules: [
                  {
                    required: isRequired,
                    lang,
                    label,
                    validator: this.judgeEmpty,
                  },
                  { validator, lang, type },
                ],
              })(
                <InputComponent
                  className="personalInfoInput__item--input"
                  placeholder={placeholder}
                  {...restProps}
                />
              )}
            </Form.Item>
          );
        })}
      </Form>
    );
  }
}

export default Form.create()(PersonalInfoInput);



// WEBPACK FOOTER //
// ./src/components/formList/gameForm/personalInfoInput/index.js